export default class CountAnimation {
    constructor() {
        this.lists = document.querySelectorAll(".js-chromeriver-list");
    }

    //region methods
    init() {
        if (this.lists.length === 2 && window.innerWidth > 489) {
            this.listItemHeightController();
        }
    }

    listItemHeightController() {
        const firstListItems = this.lists[0].querySelectorAll(".js-chromeriver-list-item");
        const secondListItems = this.lists[1].querySelectorAll(".js-chromeriver-list-item");
        for (let i = 0; i < firstListItems.length; i++) {
            if (secondListItems[i] != null) {
                if (firstListItems[i].offsetHeight >= secondListItems[i].offsetHeight) {
                    secondListItems[i].style.height = firstListItems[i].offsetHeight + "px";
                } else {
                    firstListItems[i].style.height = secondListItems[i].offsetHeight + "px";
                }
            }
        }
    }

    //endregion
}
